module.exports = __webpack_public_path__ + "img/arrow_down_2.55b1a368.svg";